"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZrxSwapper = void 0;
const types_1 = require("@shapeshiftoss/types");
const getZrxMinMax_1 = require("./getZrxMinMax/getZrxMinMax");
const getZrxTradeQuote_1 = require("./getZrxTradeQuote/getZrxTradeQuote");
const helpers_1 = require("./utils/helpers/helpers");
const ZrxApprovalNeeded_1 = require("./ZrxApprovalNeeded/ZrxApprovalNeeded");
const ZrxApproveInfinite_1 = require("./ZrxApproveInfinite/ZrxApproveInfinite");
const zrxBuildTrade_1 = require("./zrxBuildTrade/zrxBuildTrade");
const zrxExecuteTrade_1 = require("./zrxExecuteTrade/zrxExecuteTrade");
class ZrxSwapper {
    constructor(deps) {
        this.deps = deps;
    }
    getType() {
        return types_1.SwapperType.Zrx;
    }
    async buildTrade(args) {
        return (0, zrxBuildTrade_1.zrxBuildTrade)(this.deps, args);
    }
    async getTradeQuote(input) {
        return (0, getZrxTradeQuote_1.getZrxTradeQuote)(input);
    }
    async getUsdRate(input) {
        return (0, helpers_1.getUsdRate)(input);
    }
    async getMinMax(input) {
        return (0, getZrxMinMax_1.getZrxMinMax)(input.sellAsset, input.buyAsset);
    }
    async executeTrade(args) {
        return (0, zrxExecuteTrade_1.zrxExecuteTrade)(this.deps, args);
    }
    async approvalNeeded(args) {
        return (0, ZrxApprovalNeeded_1.ZrxApprovalNeeded)(this.deps, args);
    }
    async approveInfinite(args) {
        return (0, ZrxApproveInfinite_1.ZrxApproveInfinite)(this.deps, args);
    }
    filterBuyAssetsBySellAssetId(args) {
        const { assetIds = [], sellAssetId } = args;
        return assetIds.filter((id) => id.startsWith('eip155:1') && (sellAssetId === null || sellAssetId === void 0 ? void 0 : sellAssetId.startsWith('eip155:1')));
    }
    filterAssetIdsBySellable(assetIds = []) {
        return assetIds.filter((id) => id.startsWith('eip155:1'));
    }
}
exports.ZrxSwapper = ZrxSwapper;
ZrxSwapper.swapperName = 'ZrxSwapper';
